<!--
================================================
Composant permettant d'éditer un timerecord

Url d'accès :
http://localhost:8080/fr/cronocloud-inc/timeclock

Description :
*     * La prop timerecord passée au comp est clonée dans un objet mutableTimerecord

// NOTE :  J'ai dû désactiver les input direct dans les dates picker allowInput, en effet au final je ne parvenais pas à maintenir une bonne synchro entre la valeur entrée directement dans l'input et celle envoyée.

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="ModalTimerecordsEditionComp">
        <div class="modal" id="modalTrEdition"
             v-bind:class="{ 'is-active': isVisible }"
             v-on:keyup.esc="hide" tabindex="0"
        >

            <!--ajouter la classe is-active sur.modal pour afficher-->
            <div class="modal-background"></div>
            <div class="modal-card" >
                <header class="modal-card-head">
                    <p class="modal-card-title has-text-left">{{$t('ModifierUnPointage')}}</p>
                    <button v-on:click="toggleVisibility()" id="closeModalTrEdit" class="delete"
                            aria-label="close"></button>
                </header>
                <section class="modal-card-body">

                    <div class="trInfos">
                        <font-awesome-icon :icon="['fas', 'desktop']" class="icon"/>
                        <span v-bind:title="$t('votreAdresseIpEstModifiéeAutomatiquement')" class="slug "> {{$t('adresseIp')}} <span
                                class="id">{{timerecord.ipAddress}}</span></span>


                        <span class=" duration is-pulled-right ">
                                <font-awesome-icon :icon="['fas', 'stopwatch']" class="icon"/>
                                <span> {{$t('durée')}} : {{duration}}</span>
                            </span>
                    </div>


                    <form action="" v-on:keyup.enter="validateBeforeSubmit">

                        <div class="field in">

                            <label class="label" for="">
                                <font-awesome-icon :icon="['fas', 'sign-in-alt']" class="icon"/>
                                {{$t('entrée')}}</label>
                            <div class="control" id="controlTimeIn">
                                <flat-pickr v-model="timeInNewValue"
                                            :config="config"
                                            class="input"
                                            v-bind:placeholder="$t('choisissezUneDateDentrée')"
                                            v-validate="{required:true}"
                                            id="trEditModal_timeIn"
                                            name="trEditModal_timeIn"

                                ></flat-pickr>

                            </div>

                            <p class="help is-danger has-text-left" id="error_trEditModal_timeIn">{{errors.first('trEditModal_timeIn') }} </p>


                        </div>


                        <!--//////////////////////////////////// -->
                        <div class="field out">
                            <label class="label" for="">
                                <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="icon"/>
                                {{$t('sortie')}}</label>

                            <div class="control" id="controlTimeOut">

                                <flat-pickr v-model="timeOutNewValue"
                                            :config="config"
                                            v-on:open="onOpen()"
                                            class="input"
                                            v-bind:placeholder="$t('choisissezUneDateDeSortie')"
                                            v-validate="{required:true}"
                                            id="trEditModal_timeOut"
                                            name="trEditModal_timeOut"
                                            @on-change="onChange()"


                                ></flat-pickr></div>

                            <p class="help is-danger has-text-left" id="error_trEditModal_timeOut">
                                {{errors.first('trEditModal_timeOut') }}</p>
                            <p class="help is-danger has-text-left" id="error_spe_after" v-show="clockoutBeforeClockin">
                                {{$t('DateDeFinDoitEtrePostérieur') }}</p>


                        </div>
                        <!--//////////////////////////////////// -->

                    </form>

                </section>
                <footer class="modal-card-foot">
                    <a v-on:click="toggleVisibility()" class="button is-text cancelLink">{{$t("annuler")}}</a>
                    <a v-on:click="validateBeforeSubmit()" v-bind:class="{'is-loading':isSubmiting}" v-bind:disabled="isSubmiting"
                       class="button is-primary validBtn " id="submitModalTrEdit" >{{$t("valider")}}</a>
                </footer>

            </div>

        </div>
    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import TimeMixin from "../mixins/TimeMixin.js";
    import _ from 'lodash'
    import timeTrackingView from "@/views/TimeTrackingView";
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'ModalTimerecordsEditionComp', //utile dans vue dev tool
        mixins: [TimeMixin, InterceptorMixin, SentryMixin, GlobalErrorNotification, TrackingMixin],
        components: {},
        // props: [''],
        data: function () {
            return {

                timeInNewValue: null,   // la nouvelle date d'entrée
                timeOutNewValue: null,  // la nouvelle date de sortie
                clockoutBeforeClockin: false, // un bool qui indique si la date dans inputOut est antérieure à la date dans

                locale: this.$route.params.locale,
                isSubmiting: false, // indique si le formulaire est en cours de soumission

                // pour les composants où l'user est identifié ///////////////////////
                organizationSlug: this.$route.params.organization,
                userSlug: JSON.parse(this.$cookie.get('auth')).userSlug,
                // =================================================================
            }
        },

        computed: {
            // computed props for store :
            ...mapState({
                user: state => state.user,
                isVisible: state => state.ModalTimerecordsEditionComp.isVisible,
                timerecord: state => state.ModalTimerecordsEditionComp.timerecord,
                MyRecentActivityCompTimerecords: state => state.MyRecentActivityComp.timerecords,
            }),



            // clone de l'ojet timerecord (du store) que l'on édite, je le copie le temps de le manipuler dans les champs datepicker car sinon cela affecte l'affichage dans le tableau TimerecordTableLineComp
            mutableTimerecord: {
                get: function () {
                    return _.clone(this.timerecord)
                },

            },

            // la durée du timerecord (est mis à jour en temps réel pour donner un aperçu lors de l'édition)
            duration: {
                get: function () {
                    let duration = this.calculateDuration(this.$moment, this.timeInNewValue, this.timeOutNewValue)
                    return this.formatDuration(duration, this.$moment, this.locale)
                },
            }

            // la configuration pour flatpickr https://flatpickr.js.org/options/
            ,config: {
                get: function () {
                   return  {
                            wrap: false, // set wrap to true only when using 'input-group'
                            altFormat: this.$datepickerI18nConf.altFormat, // le format de date affiché dans l'input, localisé car visible par l'user | ex 15 min avant noël : (fr) 25/12/19 23:45 (en) 12/25/19 11:45 PM .
                            dateFormat: 'Y-m-d H:i:S', //  le format dans l'attribut value | ex : 2019-12-25 23:45:00 |
                            altInput: true, //Show the user a readable date (as per altFormat), but return something totally different to the server.
                            altInputClass: 'datepicker input',
                            enableTime: true,
                            minuteIncrement: 1,
                            allowInput: false, //  Allows to enter a date directly in the input field
                            locale: this.$datepickerI18nConf.locale, // locale for this instance only
                            time_24hr: this.$datepickerI18nConf.time_24hr,
                    }
                }
            }

        },

        watch: {
            mutableTimerecord: function (){
             // quand mutableTimerecord est updaté on mets à jour les valeurs timeInNewValue & timeOutNewValue pour hydrater les pickers, permet d'hydrater les datepicker et d'afficher la valeurs dans le timezone de l'utilisateur
             this.timeInNewValue = this.$moment(this.mutableTimerecord.timeIn).tz(this.user.timezone).format('Y-MM-DD HH:mm')
             this.timeOutNewValue = this.$moment(this.mutableTimerecord.timeOut).tz(this.user.timezone).format('Y-MM-DD HH:mm')

            },
            isVisible: function () {
                // tracking mixpanel (affichage/masquage de la modale)
                if (this.isVisible===true){
                  this.ga4GlobalEventTrack('Timerecord edition modal opened' , {})

                  this.$mixpanel.track("[ModalTrEdit] opened",);}
            }
        },

        methods: {

            /**
             * À chaque fois que la date change on remet l'affichage du message d'erreur clockoutBeforeClockin à false ( car sinon le message ne se masque pas avant la validation du form alors qu'une date correcte peut avoir été sélectionnée entre temps)**/
            onChange() {
                this.clockoutBeforeClockin = false;
            },

            /*
             Toggle l'affichage de la modal
             */
            toggleVisibility() {
                if (this.isVisible === true) {
                    this.hide()
                } else {
                    this.show()
                }
            },


            /*
            Masque la modal
             */
            hide() {
                this.$store.commit('UpdateModalTimerecordsEditionComp', {
                    'isVisible': false,
                    timerecord: this.timerecord
                })
            },


            /**
             * Retourne true si timeOut est une date supérieur à timeIn
             * @param timeIn
             * @param timeOut
             */
            timeOutIsAfter(timeIn, timeOut) {
                if (this.$moment(timeOut).isAfter(timeIn))
                {
                    this.clockoutBeforeClockin =false
                    return true
                } else {
                    this.clockoutBeforeClockin =true
                    return false
                }
            },

            /**
             * Valide le form avant soumission
             * N'ayant pas réussi à traiter la contrainte de validation after via vu validate, c'est ici que l'on vérifie si la date de sortie est bien postérieure à la date d'entrée.
             **/
            validateBeforeSubmit(){

                let self =this;
                this.$validator.validateAll().then((result) => {
                    if (result) { // si la validation. réussie
                        if (self.timeOutIsAfter(self.timeInNewValue, self.timeOutNewValue)){
                            this.sendEditQuery()
                        }
                    }
                    else{ // si il y a des erreurs...
                        self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-danger',
                            'message': self.$t('leFormulaireContientDesErreurs')
                        });
                        // this.isSubmiting = false;
                    }

                })
            }


            /**
             Formate date pour l'envoyer au format de l'api REST
                * définit le marquage json pur l'api REST
                * formate en UTC

             Le formatage est effectué avec moment (https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/)

             * @param date | {string} (au format 2019-08-19 10:45:00)
             * @return {{date: {month: number, year: number, day: number}, time: {hour: number, minute: number}}}
             */
            , formatDate(date) {

                // on créé une date au timezone de l'utilisateur
                let momentDate = this.$moment.tz(date, 'YYYY-MM-DD HH:mm:ss', this.user.timezone)//  vu sur https://stackoverflow.com/questions/15347589/format-date-in-a-specific-timezone

                // on envoie les dates en les convertissant en utc !
                return {
                    date: {
                        year: parseInt(momentDate.utc().format('Y')),
                        month: parseInt(momentDate.utc().format('MM')),
                        day: parseInt(momentDate.utc().format('DD'))
                    },
                    time: {
                        hour: parseInt(momentDate.utc().format('HH')),
                        minute: parseInt(momentDate.utc().format('mm'))
                    }
                }
            }


            /**
             * Envoie la requête patch de modification
             * @return {Promise<{} | never>}
             */
            ,sendEditQuery(){

                this.isSubmiting = true;

                let self = this
                return self.$http
                    .patch(`/organizations/${self.organizationSlug}/users/${self.userSlug}/timeRecords/${self.timerecord.slug}`,
                        {

                            timeIn: self.formatDate(self.timeInNewValue),
                            timeOut: self.formatDate(self.timeOutNewValue),
                        },
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {

                        self.hide()

                        self.updateTimerecords(response.data)

                        self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-success',
                            'message': self.$t('lePointageAÉtéModifié'),
                            'duration': 3200

                        });

                        // tracking
                        self.$mixpanel.track("timerecord edited", {"timerecord":self.timerecord.slug});
                        self.ga4GlobalEventTrack('Timerecord edited' , {})


                      return {}
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0003'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error on editing timerecord', 'fatal': false})

                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error editing timerecord"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error on editing timerecord : ${error}`, 'error')
                        }
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            }


            /**
             * Met le store à jour avec editedTimerecord
             * Cela permet que le timerecord modifié soit mis à jour dans MyRecentActivityComp
             *
             * inspiré de https://stackoverflow.com/questions/27641731/is-there-a-function-in-lodash-to-replace-matched-item
             *
             * @param editedTimerecord object le timerecord mis à jour (retourné par l'api REST) dans sendEditQuery()
             *
             */
            ,updateTimerecords(editedTimerecord){

                // on remplace le projet édité dans le store

                // Trouve l'index de l'objet à remplacer dans le store
                // Find item index using _.findIndex
                var index = _.findIndex(this.MyRecentActivityCompTimerecords, {slug: this.timerecord.slug});

                // Replace l'objet à l'index précédemment trouvé
                this.MyRecentActivityCompTimerecords.splice(index, 1, editedTimerecord);

            }

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        // updated: function(){},
        // mounted: function () {
            // this.logToSentry(this, 'push a log to sentry :)', 'info')
        // }

    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/


    .modal {

        // DATEPICKER -----------------------------------------------
        .datepicker {
            color: $brandThird;
            padding: 1.4rem !important;
        }

        color: $brandFourth;

        .modal-card-title {

        }


        .trInfos {

            font-size: 0.85rem;
            font-weight: bold;

            .icon {
                color: #e2e6e7;
                height: 1rem;
            }

            .slug {
                .id {
                    margin-left: 0.5rem;
                    border-radius: 2px;
                    background: #e2e6e7;
                    color: white;
                    padding: 0.1rem 0.4rem;
                }
            }

        }

        form {
            margin-top: 2rem;

            $size: 0.85rem;

            .icon {
                height: $size
            }

            .label {
                font-size: $size;
                color: $brandFourth;
                margin-top: 2rem;
            }

            .field.in {

                .label {
                    color: $brandPrimary;
                }

                .icon {
                    color: $brandPrimary;
                }
            }

            .field.out {
                .label {
                    color: $brandRed;
                }

                .icon {
                    color: $brandRed
                }
            }

            .input {
                color: $brandFourth;
            }

            .field.comment {
            }

        }

    }


</style>
